"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createColors = void 0;
const lodash_merge_1 = __importDefault(require("lodash.merge"));
const create_theme_1 = require("./create-theme");
const dark_1 = __importDefault(require("./schemes/dark"));
const light_1 = __importDefault(require("./schemes/light"));
const commonColors = {
    black: "#000000",
    white: "#ffffff",
};
const defaultPalette = {
    ...commonColors,
    ...light_1.default,
};
function createColors(schemes = {}) {
    return {
        colors: defaultPalette,
        colorScheme: create_theme_1.defaultScheme,
        schemes: (0, lodash_merge_1.default)({
            light: light_1.default,
            dark: dark_1.default,
        }, schemes),
    };
}
exports.createColors = createColors;
exports.default = createColors;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlYXRlLWNvbG9ycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3RoZW1pbmcvY3JlYXRlLWNvbG9ycy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSxnRUFBaUM7QUFHakMsaURBQStDO0FBQy9DLDBEQUF3QztBQUN4Qyw0REFBMEM7QUFpQjFDLE1BQU0sWUFBWSxHQUFpQjtJQUNqQyxLQUFLLEVBQUUsU0FBUztJQUNoQixLQUFLLEVBQUUsU0FBUztDQUNqQixDQUFDO0FBQ0YsTUFBTSxjQUFjLEdBQUc7SUFDckIsR0FBRyxZQUFZO0lBQ2YsR0FBRyxlQUFXO0NBQ2YsQ0FBQztBQUVGLFNBQWdCLFlBQVksQ0FBQyxVQUF1QyxFQUFFO0lBQ3BFLE9BQU87UUFDTCxNQUFNLEVBQUUsY0FBYztRQUN0QixXQUFXLEVBQUUsNEJBQWE7UUFDMUIsT0FBTyxFQUFFLElBQUEsc0JBQUssRUFDWjtZQUNFLEtBQUssRUFBRSxlQUFXO1lBQ2xCLElBQUksRUFBRSxjQUFVO1NBQ2pCLEVBQ0QsT0FBTyxDQUNSO0tBQ0YsQ0FBQztBQUNKLENBQUM7QUFaRCxvQ0FZQztBQUVELGtCQUFlLFlBQVksQ0FBQyJ9